import { z } from 'zod';

export const UserId = z.string().regex(/^[\dA-Z]{28,36}$/);

export type UserId = z.infer<typeof UserId>;
